export default {
  contexts: {
    push: {
      passwordReset: {
        buttonText: 'Send Request To Phone',
        subheaderText: 'This extra step proves your identity. We\'ll send a push notification to your phone through JumpCloud Protect.',
      },
      login: {
        buttonText: 'Send Login Request To Phone',
        subheaderText: 'This extra step proves your identity. We\'ll send a push notification to your phone through JumpCloud Protect.',
      },
    },
    totp: {
      passwordReset: {
        buttonText: 'Reset Password',
        subheaderText: 'This extra step proves your identity. You\'ll need to use your registered authenticator app.',
      },
      login: {
        buttonText: 'Login',
        subheaderText: 'This extra step proves your identity. You\'ll need to use your registered authenticator app.',
      },
    },
    webauthn: {
      passwordReset: {
        buttonText: 'Verify With Security Key or Device Biometric',
        subheaderText: 'This extra step proves your identity. You\'ll need your USB security key or device biometric (such as Touch ID or Windows Hello).',
      },
      login: {
        buttonText: 'Login with Security Key or Device Biometric',
        subheaderText: 'This extra step proves your identity. You\'ll need your USB security key or device biometric (such as Touch ID or Windows Hello).',
      },
    },
  },
};
